
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import DepartmentEdit from '@/components/Department/DepartmentEdit.vue';

@Component({
  components: {
    DepartmentEdit,
  },
})
export default class DepartmentEditButton extends Vue {
  @Prop(String) public id!: string;
  public showDialog = false;

  @Emit()
  public departmentUpdated() {
    this.showDialog = false;
  }
}
